import api from '../services/api';
import { IMail } from '../shared/interfaces';

export const getMail = async (): Promise<IMail> => {
  const response = await api.get('/mail');
  return response.data;
};

export const postMail = async (payload: any): Promise<IMail> => {
  const response = await api.post('/mail', payload);
  return response.data;
};

export const patchMail = async (
  id: string | undefined,
  payload: any,
): Promise<IMail> => {
  if (!id) {
    throw new Error('ID do e-mail não fornecido.');
  }
  const response = await api.patch(`/mail/${id}`, payload);
  return response.data;
};
